import './UpdateApplication.css'
import UpdatePatentApplicationForm from '../UpdatePatentApplicationForm/UpdatePatentApplicationForm';
import UpdateTrademarkApplicationForm from '../UpdateTrademarkApplicationForm/UpdateTrademarkApplicationForm';


export default function UpdateApplication({user, applicationType, application, updateApplication, toggleNotifications}) {
  

  return (
    <div className='UpdateApplication modal fade' id={`updateApplicationModal`}  data-bs-keyboard="true">
        <div className="modal-dialog">
            <div className="modal-content formContainer">
                <div className='header'>
                    <div className='left'>
                        <div className='first'>
                            <svg width="25" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                                <rect x="1.47275" y="17.1" width="16.2" height="6.48374" rx="3.24187" transform="rotate(-90 1.47275 17.1)" stroke="currentColor" strokeWidth="1.2"/>
                                <rect x="8.57383" y="17.1" width="16.2" height="6.48374" rx="3.24187" transform="rotate(-90 8.57383 17.1)" stroke="currentColor" strokeWidth="1.2"/>
                            </svg>
                        </div>
                        <div className='second'>
                            <div className='sec1'>
                                {`Update Application "${application.RPNumber}"`}
                            </div>
                        </div>
                    </div>
                    <div className='right'>
                        <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                            <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className='mainContainer'>
                  { applicationType &&
                  <>
                  { applicationType === 'patent' &&
                  <UpdatePatentApplicationForm user={user} toggleNotifications={toggleNotifications} patentApplication={application} updateApplication={updateApplication} />
                  }
                  { applicationType === 'trademark' &&
                  <UpdateTrademarkApplicationForm user={user} toggleNotifications={toggleNotifications} trademarkApplication={application} updateApplication={updateApplication} />
                  }
                  </>
                  }
                </div>
            </div>
        </div>
    </div>
  )
}
